import { Text } from '@village/ui';
import styled from 'styled-components';
import { device } from 'utils/device';

// TODO: remove h3 overrides once new brand is in village-ui
const Title = styled(Text)`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
    font-size: 3rem;
    font-weight: 300;
    line-height: 1.25;

    @media ${device.maxTablet} {
        font-size: 2.125rem;
        line-height: 1.2;
    }
`;

const BackButton = styled.div`
    position: absolute;
    left: -1.25rem;
    top: 1.15rem;
    cursor: pointer;

    @media (hover: hover) {
        &:hover {
            opacity: 0.6;
        }
    }

    @media ${device.maxTablet} {
        display: none;
    }
`;

const Container = styled.div`
    display: grid;
    gap: 2.5rem;

    @media ${device.minLaptop} {
        gap: 2.5rem;
        grid-template-columns: 1.4fr 1fr;
    }

    @media ${device.minLaptopL} {
        gap: 6.25rem;
        margin: 0 auto;
        max-width: 1344px;
    }
`;

const FormContainer = styled.div`
    position: relative;
    padding: 0 1rem;
`;

const WarningContainer = styled.div`
    margin: 2.5rem 0;
`;

export { BackButton, Container, FormContainer, Title, WarningContainer };
